import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertMessageComponent } from './../../shared/alert-message/alert-message.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { QuestionnaireSummary } from './../../models/questionnaireSummary.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { environment } from '../../environments/environment';
import { MatIcon } from "@angular/material/icon";
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from "@angular/material/button";
import { CompanyService } from '../../service/company.service';
import { QuestionnaireService } from '../../service/questionnaire.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-all-trainee-assessments',
  standalone: true,
  imports: [MatIcon, CommonModule, MatTooltipModule, ReactiveFormsModule, MatTableModule, MatPaginator, FormsModule, TranslateModule],
  templateUrl: './all-trainee-assessments.component.html',
  styleUrl: './all-trainee-assessments.component.css'
})
export class AllTraineeAssessmentsComponent implements OnInit {

    constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private questionnaireService: QuestionnaireService,
    private translate: TranslateService
  ) {}

  isLoading = false;
  returnUrl: string = '/';
  questionnaires: QuestionnaireSummary[] = [];
  
  displayedColumns: string[] = [
  'trainee',
  'internship',
  'date',
  'actions'
  ];

  allRows: any[] = [];
  
  dataSource = new MatTableDataSource<any>();
  globalFilter: string = '';

  /** date range */
  dateRange = new FormGroup({
  start: new FormControl<Date | null>(null),
  end: new FormControl<Date | null>(null)
  });

  /** supporto date */
  startDateFilter: Date | null = null;
  endDateFilter: Date | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.isLoading = true;


 

    this.dateRange.valueChanges.subscribe(value => {
      this.startDateFilter = value?.start ? new Date(value.start) : null;
      this.endDateFilter = value?.end ? new Date(value.end) : null;
      this.applyFilter();
    });

    this.route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
      console.log("Return URL:", this.returnUrl);
    });

    this.getQuestionnaires();

  }

   goBack() {
    this.router.navigateByUrl(this.returnUrl);
  }

  getQuestionnaires(){
    
    this.questionnaireService.getTraineeQuestionnaires().subscribe(

      (data) => {this.questionnaires = data; console.log(this.questionnaires)}

    )

  }

  applyFilter() {
  const global = this.globalFilter.toLowerCase();

  this.dataSource.data = this.allRows.filter(q => {
    const fullName = `${q.firstName || ''} ${q.lastName || ''}`.trim().toLowerCase();
    const position = (q.position || '').toLowerCase();
    const internshipTitle = (q.internshipTitle || '').toLowerCase();

    const matchesGlobal =
      !global ||
      fullName.includes(global) ||
      position.includes(global) ||
      internshipTitle.includes(global);



    const rowDate = this.normalizeDate(q.dateCompilation);
    const startDate = this.normalizeDate(this.startDateFilter);
    const endDate = this.normalizeDate(this.endDateFilter);

    const matchesStartDate = !startDate || (!!rowDate && rowDate >= startDate);
    const matchesEndDate = !endDate || (!!rowDate && rowDate <= endDate);

    return matchesGlobal && matchesStartDate && matchesEndDate;
  });

  if (this.paginator) {
    this.paginator.firstPage();
  }
}

private normalizeDate(dateValue: Date | string | null | undefined): Date | null {
  if (!dateValue) {
    return null;
  }

  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  parsed.setHours(0, 0, 0, 0);
  return parsed;
}

clearFilters() {
  this.globalFilter = '';
  this.startDateFilter = null;
  this.endDateFilter = null;
  this.dateRange.reset();
  this.applyFilter();
}

  viewQuestionnaireTrainee(trainee: QuestionnaireSummary) {
    this.router.navigate(['/view-questionnaire', trainee.questionnaireId], 
                        { queryParams: { returnUrl: '/all-trainee-assessments'},
                        state: {
                            title: this.translate.instant('inclusion-index.trainee-assessment-title'),
                            subtitle: this.translate.instant('inclusion-index.trainee-assessment-subtitle'),
                            authorName: `${trainee.firstName} ${trainee.lastName}`,
                            dateCompilation: trainee.dateCompilation,
                          }
                        });
  }



}
